module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Toc_Link2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PARENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO-2"
  }, [_vm._v("When Isamu Noguchi was a boy of ten roaming the hills above the sea in Chigasaki, Japan, he searched for wild azaleas and rare blue mountain flowers to add to the primroses, violets, and daisies that already bloomed in his garden. He persuaded a local horticulturalist to give him clippings. Soon he had about fifty rosebushes irrigated by a ditch of his own devising. And, in the Japanese fashion, he placed a rock in the garden to give a feeling of weight and permanence. When he returned home from one of his plant-searching forays with muddy feet and his mother complained, he responded, “There’s such fine mud on that mountain, so rich and black and slippery. I wish we had our garden full of it.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-1",
      "id": "cha-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Noguchi decided that when he grew up he would become a landscape gardener or a horticulturalist. Years later, looking back on his childhood, he attributed his passion to embed himself and his sculpture in nature to his early years in Japan. “Primarily,” he said, “what we carry around with us is a memory of our childhood, back when each day held the magic of discovering the world. I was very fortunate to have spent my early childhood in Japan … one is much more aware of nature in Japan—not a vast panorama of nature but its details: an insect, a flower. Nature is very close, a foot away.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-2",
      "id": "cha-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Noguchi’s love of gardens with moving water and carefully placed boulders would reemerge in the many gardens that he designed beginning with his 1951 Reader’s Digest garden in Tokyo and ending in the 1980s with "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("California Scenario")]), _vm._v(", in Costa Mesa. Driven by his feeling of placelessness, Noguchi learned to invent oases for himself and others to inhabit, places where he could calm his restless energy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Although Noguchi maintained that it was through his gardens that he came to a reverence for stone, it is clear that his love affair with rocks began when he was a child. “Stone is the fundament of the earth, of the universe,” he said."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-3",
      "id": "cha-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" “We come from stone and we return to it, it is the earth itself.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-4",
      "id": "cha-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Torn between East and West, Noguchi never felt that he belonged anywhere. He called himself a “waif,” a “wanderer,” a “loner.” He was a person for whom fierce personal attachments were rare. Rocks, on the other hand, were something he could rely on. Cutting into them with chisel and hammer was a way of merging with the earth, making it his “place.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Noguchi’s childhood in Japan formed what he called “the private side” of his being."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-5",
      "id": "cha-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" His American mother, Leonie Gilmour, was, he said, his strongest influence, and it was from her that he developed an interest in art. He described his mother as shy, reserved, and sensitive. “I think I’m the product of my mother’s imagination.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-6",
      "id": "cha-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" His father, Yonejiro (Yone) Noguchi, was mostly absent. But the fact that his father was a well-known poet was something that Noguchi mentioned often with pride. In his own work Noguchi hoped to “take the essence of nature and distill it—just as a poet does.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-7",
      "id": "cha-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "353",
      "src": "images/1.1_fmt.jpeg",
      "width": "239"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP-2"
  }, [_vm._v("Leonie Gilmour")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Yone Noguchi never formally married Leonie Gilmour, and lived with her and Isamu only briefly. Nevertheless, Leonie thought that her son was more like his father than he was like her. In the introductory paragraph of his autobiography, published in 1968, Isamu wrote: “With my double nationality and double upbringing where was my home? Where my affections? Where my identity? Japan or America, either, both—or the world?”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-8",
      "id": "cha-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Twenty years later he posed the same question: “After all, for one with a background like myself the question of identity is very uncertain. And I think it’s only in art that it was ever possible for me to find any identity at all.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-9",
      "id": "cha-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" But, unlike the paintings of his contemporaries, the Abstract Expressionists, Noguchi’s sculptures did not explore his own identity, nor did they delve into the tumult of his subconscious. Rather, he sought to connect with the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD-2"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2-2"
  }, [_vm._v("Leonie Gilmour was an extraordinarily unconventional and self-reliant woman. She was five feet three and slender with light brown, wavy hair and soft gray eyes. In photographs, wearing spectacles, she looks delicate, schoolmarmish, and charmingly Irish. Her father, Andrew Gilmour, was, according to Noguchi, an Irish Protestant who emigrated from the village of Coleraine in the far north of Ireland to America sometime in the nineteenth century. Possibly he was part of the influx of Irish immigrants fleeing the potato famine of the 1840s, although there is some evidence that he left home to escape family problems."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-10",
      "id": "cha-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Noguchi, who knew Andrew Gilmour only through a photograph, said that he was “quite handsome, with a beard,” though what impressed him most was his grandfather’s intrepidness."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-11",
      "id": "cha-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" “My mother told me that he went swimming, one day in Sheepshead Bay on New Year’s day.” Perhaps it was his grandfather’s example that prompted the adult Noguchi to terrify friends by swimming far out beyond breaking waves.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("It was probably in the early 1870s that Andrew Gilmour married Noguchi’s grandmother, a nurse named Albiana Smith. She was the daughter of Aaron Smith, a fairly prosperous man of Irish descent, and a mother who was descended from a French fur trader and a Cherokee woman. Leonie, the first of Albiana’s two daughters, was born in New York City on June 17, 1874. Her younger sister Florence was born a few years later. Andrew and Albiana never divorced, but they did not live together for long. Andrew had two daughters about the same ages as Leonie and Florence by another woman, while Albiana brought up her daughters alone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Leonie and Florence attended the progressive Ethical Culture School (then called the Working Man’s School) founded in 1876 by the New York Society for Ethical Culture. The school emphasized the integration of manual and academic training and children were taught how to use tools, an experience that proved formative. Years later Leonie would apprentice her son to a carpenter, and, when he was thirteen, she sent him to a progressive boarding school that taught boys not just academics but also manual skills.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("After Ethical Culture, Leonie went to the Bryn Mawr School, a boarding school in Baltimore founded in 1884 by five young women who believed that girls should be offered as rigorous an education as boys. The school was preparatory for Bryn Mawr College and its curriculum included modern and classical languages, science, and athletics. A superior student with a keen interest in literature, the seventeen-year-old Leonie entered Bryn Mawr College outside Philadelphia in 1891 on a full scholarship. After an early focus on chemistry, she majored in history and philosophy, and in her sophomore year she won a scholarship to the Sorbonne, where she spent a year studying French literature. Noguchi maintained that his mother translated the work of the nineteenth-century French Romantic novelist George Sand, a writer whose bold novels promulgated freedom for women.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("After graduating from Bryn Mawr, Leonie lived with her mother in New York and looked unsuccessfully for editorial work. She finally took a job at Saint Aloysius Academy, a Catholic girls’ school in Jersey City, where she taught Latin and French. In the evenings she struggled with her own writing. Her letters to her great friend and fellow Bryn Mawr graduate Catherine Bunnell speak of books that she was reading—works by Schiller and the poet William Young, and George Du Maurier’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Trilby")]), _vm._v(", and they hint at her own literary ambitions: “I’ve been thinking up the plot of a problem story this afternoon. I want to write it down tomorrow if my energies don’t evaporate overnight.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-12",
      "id": "cha-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" In a joking tone, she said she hoped to get it published. Changing the subject, she said, “I got a new hat. That is, I took an old black straw hat, somewhat dingy, and with a watercolor brush and bottle of ink improved it into a suitable crowning achievement for a lady of literary and artistic tastes. A whole big bunch of cabbage roses stuck on.” Other letters allude to her loneliness and to a disappointing romance.")]), _vm._v(" "), _c('p', {
    staticClass: "TXS-2"
  }, [_vm._v("To supplement her income Leonie sought freelance editorial jobs. Early in 1901 she answered an advertisement placed in a newspaper by Yone Noguchi, who needed someone to help him with his English writings and to type his manuscripts. Yone wrote Leonie back, giving his address as 80 Riverside Drive on Manhattan’s Upper West Side:")]), _vm._v(" "), _c('p', {
    staticClass: "LTSA"
  }, [_vm._v("Miss Leonie Gilmour:")]), _vm._v(" "), _c('p', {
    staticClass: "LTI"
  }, [_vm._v("Dear Madam: Permit me! I am a young Japanese who advertised in the Herald and received your letter. I called on your place but not finding even a person.")]), _vm._v(" "), _c('p', {
    staticClass: "LTI"
  }, [_vm._v("I don’t need any English teacher—yes, I do! I want one who can correct my English composition. Can you take such a task? I suppose that you are able, with good English and literary ability. About three pages a week. How much you charge? Pray answer me!")]), _vm._v(" "), _c('p', {
    staticClass: "LTCL"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "LTCL"
  }, [_vm._v("Yone Noguchi")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "LTPS"
  }, [_vm._v("P.S. Tell me when you can see me, then we will talk about—that’s better, I suppose."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-13",
      "id": "cha-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "STX-2"
  }, [_vm._v("Leonie took the job, and within a few weeks Yone wrote to her saying how grateful he was for the work she had done. He apologized for paying her so little and asked her to work on four different manuscripts. “Am I not asking you to do too much? I am afraid I do!… And one more thing. I think that I will come to see you on next Sunday night. Say, about 8 o’clock. Doesn’t it suit you?”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-14",
      "id": "cha-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Despite Yone’s awkward English, Leonie, a lover of poetry, was happy to participate in its creation. Though Yone’s poems tended to be rhapsodic and trite, she was clearly drawn to their romanticism. A few years later she told a mutual friend: “I confess the sort of poetry I like best is that which makes me slightly drunk—and I find ideas to be not a necessary ingredient in producing the divine intoxicant—in fact they have a sobering affect ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("].”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-15",
      "id": "cha-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" As the letters and manuscripts went back and forth and as their meetings became more frequent, the tone of Yone and Leonie’s exchanges became less formal. Within a few weeks, he would sign a letter “Yours Jap friend, Y. N.”")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD-2"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2-2"
  }, [_vm._v("Yonejiro Noguchi was born in the town of Tsushima in rural central Japan on February 8, 1875, the youngest son of Denbee Noguchi, who, though he claimed Samurai descent, was a shopkeeper selling such items as geta (wooden sandals), umbrellas, and paper."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-16",
      "id": "cha-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Upon graduating from the First Prefectural Middle School, Yone moved to Tokyo, where he attended a preparatory school for Keio Academy (later to become the prestigious Keio University). Japan, after being isolated from the world for so many years, was eager to catch up with the West, and when Yone entered Keio the curriculum emphasized Western culture. Yone practiced his English and, like many students at the time, dreamed of going to America. On November 13, 1893, the eighteen-year-old Yone left school and, with only one hundred dollars in his pocket, sailed steerage class from Yokohama to San Francisco on the steamship "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Belgic")]), _vm._v(". In his autobiography Yone Noguchi recalled: “My friends saw me off at Shimbashi Station [in Tokyo]. I felt most ambitious when they wished me godspeed; but my heart soon broke down when my oldest brother, who came to Yokohama to bid me a final farewell, left me alone on the Belgic.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-17",
      "id": "cha-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "353",
      "src": "images/1.2_fmt.jpeg",
      "width": "274"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP-2"
  }, [_vm._v("Yonejiro Noguchi")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Upon his arrival in San Francisco, Yone and a group of fellow passengers found lodging at the Cosmopolitan Hotel, where he marveled at the pleasure of the sheets and soft pillow—Japanese pillows were made of wood. He was amazed also by the splendor of Californian women: “What lovely complexions, what delightfully quick steps.” American women were, to his eyes, a “revelation of freedom and new beauty.” They looked, he said, like “perfectly-raised California poppies.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-18",
      "id": "cha-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("The day after his arrival he presented a letter of introduction to a member of the Patriotic League ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Aikoku domei")]), _vm._v("), a radical group of political activists who had fled Japan and aimed to reform their country’s government."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-19",
      "id": "cha-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The league published a daily paper, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The San Francisco News")]), _vm._v(" ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Soko shinbun")]), _vm._v("), and Yone was hired without pay to deliver the paper to its two hundred subscribers. Along with several other young league members he lived at the paper’s O’Farrell Street office, sleeping on a table covered with newspaper. Yone found this life tough, but he was pleased to have time for reading, especially Lord Byron, his favorite author.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Before long, Yone realized that by associating with his Japanese coworkers he was not learning English. He therefore attended elementary school to improve his English and took various jobs cleaning, dishwashing, waiting on tables, and translating newspaper articles for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The San Francisco News")]), _vm._v(". After about a year he decided that he needed to resume his literary studies. A friend told him about Joaquin Miller, a well-known poet, essayist, and bohemian guru who lived in the Oakland Hills overlooking the bay. Yone climbed the hill to a small white house set in the midst of fruit trees and rosebushes. “I fell in love with the place at once … More than the place itself, I fell in love with Mr. Miller, whose almost archaic simplicity in the way of living and speech was indeed prophet-like.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-20",
      "id": "cha-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" To the young Yone Noguchi, the septuagenarian Miller was “the very symbol of romance and poetry.” Miller had long white hair and an even longer white beard. He wore a cowboy hat and boots, a red sash for a belt, and a diamond ring, and he sometimes threw a bearskin over his shoulders. Occasionally he dressed more formally in a dark double-breasted vest and a dark felt hat. He had worked as a mining-camp cook, a lawyer, a judge, a newspaper writer, a Pony Express rider, and a horse thief (for which he was briefly incarcerated). During the Gold Rush years he moved to Northern California, lived in a Native American village, and married a Native American woman. He had a number of wives but when Yone met him he was single.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Called the “Poet of the Sierras” and the “Byron of the Rockies,” Miller was the author of several books of poetry, the most famous of which was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Songs of the Sierras")]), _vm._v(", published in 1870. One of his poems, “Columbus,” was memorized by schoolchildren and ended with “Sail on! Sail on! Sail on!! And on!,” a line that Yone Noguchi remembered Miller reciting in a voice that “leapt like a leaping sword.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-21",
      "id": "cha-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" From 1886 until his death, in 1913, Miller lived at “The Hights” (the name he gave to his Oakland Hills home). He wrote poetry in the morning, planted trees and shrubs in the afternoon, and built monuments to General John C. Frémont, Robert Browning, and Moses. To the north of his house he built his own funeral pyre.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("When Yone appeared at his door, Miller must have been charmed by the young man’s handsome face with its chiseled jawline, sensuous mouth, and large, dark, sensitive-looking eyes. He invited Yone to stay in a cabin attached to his own. Instead of paying for his keep, Yone cooked breakfast and dinner and performed various odd jobs. Finally having found a home that made him happy, Yone made the decision of his life: “I secretly decided that I would become a poet.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-22",
      "id": "cha-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" He spent his mornings writing poetry and reading. Edgar Allan Poe and Walt Whitman were his favorite Americans, but he also read the great seventeenth-century haiku poet Bash"), _c('span', {
    staticClass: "accent-1"
  }, [_vm._v("ō")]), _vm._v(" and a book about Zen Buddhism. In the afternoons he helped Miller garden and clear land. He took to heart Miller’s advice to be intimate with nature and to value silence. During the four years that Yone spent at The Hights, the two men spoke very little.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("In June 1896 Yone published five poems in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Lark")]), _vm._v(", a San Francisco journal to which Joaquin Miller was also a contributor. This first entry into the world of print was for Yone “the greatest of joys, and I never felt anything like it again.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-23",
      "id": "cha-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The following year he published his first book, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Seen and Unseen, or Monologue of a Homeless Snail")]), _vm._v(". After a period of embedding himself in nature at Yosemite, in 1897 he published a second book of poems, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Voice of the Valley")]), _vm._v("."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-24",
      "id": "cha-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" In spite of his clumsy English and rather maudlin, hyberbolic rhetoric, his poems were well received in San Francisco literary circles. Readers were impressed that a young Japanese man was writing in English about his passionate response to nature. His work seemed delightfully exotic, a bridge between East and West.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Prompted by what he called his “mad desire to ally my soul to the heart of Nature as nakedly as possible” and “to heed the calling voice of trees, hills, waters, and skies in the distance,” Yone embarked on what he called “tramp-journies.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-25",
      "id": "cha-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" His models were Bash"), _c('span', {
    staticClass: "accent-1"
  }, [_vm._v("ō")]), _vm._v(", who wrote poetry while traveling by foot in northern Japan, and the eighteenth-century Anglo-Irish writer and poet Oliver Goldsmith, who liked to go “vagabondising” in Europe. Yone set out for the Yosemite Valley. After a night under the stars he wrote a poem, the first lines of which read, “Oh Repose, whose bosom harbors the heavenly dream-ships, welcome me, an exiled soul! / Thou, Forest, where Peace and Liberty divide their wealth with even a homeless convict.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-26",
      "id": "cha-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("At the outset of his next tramp journey to Southern California, he wrote in his diary: “Silence is eloquent; the universe talks much. Solitude does not simply mean loneliness, but warm familiarity. I love the solitary life. I decided to walk along the shore all night. I wrote a poem.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-27",
      "id": "cha-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Yone tramped to Los Angeles again in 1899. This time he seems to have left The Hights without informing friends of his plans, and one friend, Kosen Takahashi, wrote to a mutual acquaintance that Yone was his “eloping lover.” He had wooed Yone “as a boy do so for a girl,” Takahashi said."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-28",
      "id": "cha-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("When Yone returned to Miller’s cabin in early April 1899, he resumed work on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("O’cho-san’s Diary")]), _vm._v(", a book inspired by the publication of John Luther Long’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Madame Butterfly")]), _vm._v(". (Titled "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The American Diary of a Japanese Girl")]), _vm._v(", it would be published two years later in three installments in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Leslie’s Monthly")]), _vm._v(", and as a book in 1902.) The diary is the story of the visit to America of Miss Morning Glory, a feisty and independent girl, quite different from the stereotype of the self-abnegating Japanese woman. For help with his English prose, Yone often called upon Blanche Partington, a cultural reporter for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The San Francisco Call")]), _vm._v(". On July 12, 1898, he had written Blanche: “I am writing on O’cho-san’s Diary more and more. I wish therefore, you will work on with it when you got back to your home, for the preparation to make it appear in some newspaper.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-29",
      "id": "cha-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" But his relationship with Partington was fraught. Yone could be demanding and childish if he did not get his way, and as Partington tired of his whining, she tried to extricate herself from his demands.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Though he enjoyed California, Yone knew that to establish a literary reputation, acceptance in Manhattan counted for more than success in San Francisco. In May 1900 he headed east, traveling by train first to Chicago, where he stayed for about a month, working on essays about his impressions of the city commissioned by "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Evening Post")]), _vm._v(". He then moved on to New York, which he described to Partington as a “monster with the head of Goddess and the four legs of animal … New York is the warmest heart like a mother, and is the coldest like a razer ["), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sic")]), _vm._v("].”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-30",
      "id": "cha-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" This seems to have been his last letter to Partington until four years later, when he passed through San Francisco on his way home to Japan. Within six months of his arrival in New York, he had found Leonie Gilmour, who could take over Partington’s editorial role.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("A few days after Yone arrived in Manhattan he was pickpocketed and wrote a friend of Joaquin Miller’s for a loan. Charles Warren Stoddard, once part of California’s literary bohemia, was a gay poet best known for his collections of homoerotic stories recalling his sojourns in the South Sea Islands, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("South-Sea Idyls")]), _vm._v(" (1874), and for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Island of Tranquil Delights")]), _vm._v(" (1904). He liked to befriend very young men and was always in search of what he called a “Kid.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-31",
      "id": "cha-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" “I am so much down-hearted,” Yone wrote, “Help me! Will you? Help me!”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-32",
      "id": "cha-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Stoddard sent ten dollars and in August Yone went to Washington, D.C., to meet Stoddard for the first time. Although the forty-seven-year-old Stoddard wrote in his diary that he had been disappointed that Yone had not turned up wearing a kimono, he was smitten."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-33",
      "id": "cha-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" When Yone returned to New York after a stay of several weeks in Stoddard’s “Bungalow,” he wrote to his host: “My dear Charlie. How rare your sweet magnetism! Your breath so soft and impressive like Autumn rain! Your love—thank God! so heavenly!”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-34",
      "id": "cha-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Turn-of-the-century letters often suggest a sexual intimacy between same-sex correspondents when in fact the writer is merely expressing fondness. Yone did, however, avow in an article about Stoddard’s “Bungalow” published in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The National Magazine")]), _vm._v(" that he sometimes slept with Stoddard. In New York, Yone took a room at 80 Riverside Drive and then moved to a Japanese boardinghouse at 41 East Nineteenth Street. He spent the next year finishing his "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Diary of a Japanese Girl")]), _vm._v(", which would be published as a book by Frederick A. Stokes. A year and a half after his first visit to Washington, D.C., Yone sent Stoddard a photograph of himself, to which Stoddard waxed euphoric, calling him his baby. “I must nurse you well, and take such very, very good care of you.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-35",
      "id": "cha-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Another of Stoddard’s letters said he wanted to hold Yone in his lap and fondle him and at night he would embrace him, “the two of us upon the one pillow … Now come, place your lips to mine in one long rapturous kiss!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Yone Noguchi’s apparently amorous relationships with men did not preclude heterosexual interests. It was probably late in 1901, a few months after Leonie began working for him, that he met and fell in love with the twenty-five-year-old Ethel Armes, a cultural reporter for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Washington Post")]), _vm._v(". Although he could have asked Ethel to edit his work, he continued sending it to Leonie. His letters to her comment (most often favorably) on his own writing, but he insisted that she be frank in her evaluations of his efforts: “Say, Leonie, cut it short if you want! Change words if they don’t fit properly … Don’t be afraid.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-36",
      "id": "cha-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Leonie, it appears, also took to asking Yone for advice on her own work. When in 1901 she sent him one of her stories, he told her it was too realistic. “Your story … has not much value, I declare.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-37",
      "id": "cha-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" He also objected to her story’s moral position; it had defended a divorced woman who planned to remarry: “I don’t think that people can change husband or wife as if with socks or underwear.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Around this time he told Leonie of a story he had written about the misery of an American woman married to a Japanese man. “Crow should be in comradeship with crow,” he wrote. Perhaps Yone was trying to warn Leonie not to become infatuated with him. But Leonie was more and more drawn to Yone, whom she admired as a poetic creature whose physical beauty, boyish charm, and evident need for her were no doubt seductive. Nonetheless, they continued to quarrel. In a letter of September 10, 1901, Yone wrote, “Dear Leonie. Please don’t! Let us laugh!” Three weeks later they have had yet another contretemps. Apparently he had lost his temper with her—like his son Isamu, Yone was prone to flashes of rage. Perhaps to placate Leonie and to keep her working on his manuscripts, he encouraged her to send one of her stories to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Red Book")]), _vm._v("."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-38",
      "id": "cha-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Probably the chief cause for her pique was that he had told her that their relationship was no different from his relationship with his male companions—an ungallant assertion, to be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Yone had been in Rochester, New York, for several months when he wrote to Leonie in September 1902 saying that he planned to return to New York City in October and then to go on to London. There he took up lodgings with Yoshio Makino, a Japanese artist friend who lived in southwest London, and, having failed to find a publisher for his poetry, he decided to self-publish "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("From the Eastern Sea")]), _vm._v(", a sixteen-page pamphlet of eight poems. Makino designed the cover and Yone sent his slim volume to people such as William Butler Yeats, Laurence Binyon, and William Michael Rossetti. Rossetti made some minor revisions to Yone’s text and wrote him that the poems were “full of a rich sense of beauty, and of ideal sentiment.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-39",
      "id": "cha-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Binyon wrote that the book had “an atmosphere of beauty and suggestion which is peculiar to itself and unlike anything we have already.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-40",
      "id": "cha-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Thanks to the favorable critical response, the University Press published an expanded version of the book, which Yone dedicated to Stoddard. Just before Christmas he received a letter from Ethel Armes telling him that she was engaged and that Yone should not have abandoned her. Meanwhile Stoddard continued to write, discouraging Yone from marrying Ethel and applauding his literary success. With people like Algernon Charles Swinburne and Rossetti praising him, Stoddard said, Yone’s fame was certain to be instant, like Lord Byron’s.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("Back in the United States, Yone’s relationship to Leonie remained businesslike, but there were signs of increasing intimacy. “Are you deadly tired of me?” he asked in a teasing letter. “I am something like a jellyfish which has no head and tail. I don’t know what I am going to do … (Anyhow, what’s the matter with you?) You are quite blue, aren’t you? Come, now, it’s awfully foolish to be blue.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-41",
      "id": "cha-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" He was, he said, planning to go to Japan. Most likely this was the cause of Leonie’s sadness. Instead of departing, he made a promise of a permanent bond with Leonie. On November 18, 1903, he wrote one line on a page from a notebook: “I declare that, Leonie Gilmour is my lawful wife.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-42",
      "id": "cha-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Perhaps she required such a vow before they became lovers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("After this marriage delaration, Leonie appears to have moved in with him at his apartment at 121 West Sixty-fourth Street. Their cohabitation probably lasted about half a year. (There are no letters from him to her during this period.) In February she became pregnant, but neither this nor his “marriage” to Leonie prompted Yone to end his relationship with Ethel. Indeed in June 1904, when Leonie was four months pregnant, he wrote to Stoddard that he was still planning to marry Ethel. On August 3, 1904, Yone left New York, traveling by train first to Birmingham, Alabama, where he stayed with Ethel’s family for four days, and from there to San Francisco, where he boarded the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Manchuria")]), _vm._v(" bound for Japan. He appears to have had little regret at leaving the six-months-pregnant Leonie behind.")]), _vm._v(" "), _c('p', {
    staticClass: "TX-2"
  }, [_vm._v("From the Japanese point of view, Yone, having conquered the literary worlds of the West, could come home in triumph. In January 1905 he wrote to Stoddard that he was being feted with numerous receptions and that Ethel would soon join him. “We—I and Ethel—will work together and hard as possible, and build an ideal home, and then you will come. What a dream!”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-43",
      "id": "cha-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Still, Yone did not earn much money. He discovered that it was not possible for him to write and publish in Japanese. The Japanese saw Yone as too Westernized both in his writing and in his person. “With blue eyes and features like those of a foreigner it is hard to think of him as being Japanese at all,” wrote the well-known poet Sakutaro Hagiwara."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-44",
      "id": "cha-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" “I have no confidence in either language,” Yone admitted years later in a poem. “In other words, I guess I am a dual citizen.”"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#chapter1-45",
      "id": "cha-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Similarly, Isamu Noguchi would say that he belonged nowhere and was a citizen of the world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed11cd74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 75
// module chunks = 0